import React from "react";
import { InfoBoxWithGridBlade } from "@organic-return/foundation-react/src/components/Blades/InfoBoxWithGridBlade"
import { IMediaItem } from "@organic-return/foundation-react/src/lib/Media/util";
import { useSiteContext } from "../common/SiteContext";
import { graphql } from "gatsby";

export const InfoBoxWithGrid = (props: any) => {
    const siteContext = useSiteContext();
    
    let titleAlignment = "";
    switch (props.titleAlignment) {
        case "right":
            titleAlignment = "text-center lg:text-right";
            break;
        case "left":
            titleAlignment = "text-center lg:text-left";
            break;
        default:
            titleAlignment = "text-center";
            break;
    }

    const infoArray: { label: string; value?: string; valuePrefix?: string; icon?: Partial<IMediaItem> }[] = [];
    infoArray.push({
        label: props.firstInfoLabel,
        value: props.firstInfoValue,
        valuePrefix: props.firstInfoValuePrefix,
        icon: props.firstInfoIcon?.url && {
            url: props.firstInfoIcon.url,
        }
    });
    infoArray.push({
        label: props.secondInfoLabel,
        value: props.secondInfoValue,
        valuePrefix: props.secondInfoValuePrefix,
        icon: props.secondInfoIcon?.url && {
            url: props.secondInfoIcon.url,
        }
    });
    infoArray.push({
        label: props.thirdInfoLabel,
        value: props.thirdInfoValue,
        valuePrefix: props.thirdInfoValuePrefix,
        icon: props.thirdInfoIcon?.url && {
            url: props.thirdInfoIcon.url,
        }
    });
    infoArray.push({
        label: props.fourthInfoLabel,
        value: props.fourthInfoValue,
        valuePrefix: props.fourthInfoValuePrefix,
        icon: props.fourthInfoIcon?.url && {
            url: props.fourthInfoIcon.url,
        }
    });
    infoArray.push({
        label: props.fifthInfoLabel,
        value: props.fifthInfoValue,
        valuePrefix: props.fifthInfoValuePrefix,
        icon: props.fifthInfoIcon?.url && {
            url: props.fifthInfoIcon.url,
        }
    });
    infoArray.push({
        label: props.sixthInfoLabel,
        value: props.sixthInfoValue,
        valuePrefix: props.sixthInfoValuePrefix,
        icon: props.sixthInfoIcon?.url && {
            url: props.sixthInfoIcon.url,
        }
    });

    return (
        <InfoBoxWithGridBlade
            sectionClassNames="info-box-with-grid"
            title={props.title}
            titleClassNames={titleAlignment}
            infoArray={infoArray}
            bgImageUrl={props.backgroundImage?.url}
            {...siteContext.globalInfoBoxWithGridProps}
        />
    )
}

export default InfoBoxWithGrid

export const query = graphql`
fragment DrupalInfoBoxWithGridContent on DrupalInfoBoxWithGrid {
    id
    backgroundImage {
        url
    }
    title
    titleAlignment
    firstInfoValue
    firstInfoValuePrefix
    firstInfoIcon {
        url
    }
    firstInfoLabel
    secondInfoValue
    secondInfoValuePrefix
    secondInfoIcon {
        url
    }
    secondInfoLabel
    thirdInfoValue
    thirdInfoValuePrefix
    thirdInfoIcon {
        url
    }
    thirdInfoLabel
    fourthInfoValue
    fourthInfoValuePrefix
    fourthInfoIcon {
        url
    }
    fourthInfoLabel
    fifthInfoValue
    fifthInfoValuePrefix
    fifthInfoIcon {
        url
    }
    fifthInfoLabel
    sixthInfoValue
    sixthInfoValuePrefix
    sixthInfoIcon {
        url
    }
    sixthInfoLabel
}
`